import { styled } from 'next-yak';

import {
  SkeletonCard,
  SkeletonHeadline as DefaultSkeletonHeadline,
} from '@xing-com/skeleton';
import {
  scale280,
  scale440,
  spaceM,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';

export const LoadingCardContainer = styled(SkeletonCard)`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: ${spaceXL};
  height: 580px;
  max-width: ${scale440};
  padding: ${spaceXXL} !important;
  border-radius: ${spaceXXL} !important;
`;

export const LoadingCardBenefits = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXL};

  & > div:last-child {
    display: flex;
    flex-direction: column;
    gap: ${spaceM};
  }
`;

export const SkeletonHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXL};
`;

export const SkeletonHeadline = styled(DefaultSkeletonHeadline)`
  width: ${scale280};
`;
